import { render, staticRenderFns } from "./total-power.vue?vue&type=template&id=049502f5&scoped=true&"
import script from "./total-power.vue?vue&type=script&lang=js&"
export * from "./total-power.vue?vue&type=script&lang=js&"
import style0 from "./total-power.vue?vue&type=style&index=0&id=049502f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049502f5",
  null
  
)

export default component.exports